import { useEffect, useRef } from 'react';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

/**
 * A manual popover, so it lands in the top layer above any open sheet
 * (a modal <dialog> would otherwise cover it).
 */
export function Toast({ message, action }: { message: string; action?: ToastAction }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    try {
      if (!el.matches(':popover-open')) el.showPopover();
    } catch {
      /* no Popover API: it still renders in place */
    }
  }, [message]);

  return (
    <div ref={ref} className={action ? 'toast toast--action' : 'toast'} role="status" popover="manual">
      <span>{message}</span>
      {action && (
        <button type="button" className="text-link" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
